import React from 'react'
import StorageEstimator from './components/StorageEstimator'

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <h1 className="text-2xl font-bold text-gray-900">
            BEAM Storage Estimator
          </h1>
          <p className="text-sm text-gray-600 mt-1">
            AI-powered storage space estimation
          </p>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-8">
        <StorageEstimator />
      </main>

      <footer className="max-w-4xl mx-auto px-4 py-6 text-center text-sm text-gray-500">
        <p>Best-effort AI estimate—talk to a teammate if unsure.</p>
      </footer>
    </div>
  )
}

export default App
